<!-- 页头 -->
<template>
  <header class="Jp-PageHead-Component">
    <div class="inner">
      <div class="logo">
        <a @click="goHome">
          <img :src="require('@assets/img/jp/logo.png')" />
        </a>
      </div>
      <div class="spmenuopen" @click="showSp = true"></div>
      <nav class="nav">
        <template v-for="(item, index) in navList">
          <a
            v-if="item._blank"
            :key="index"
            :href="item.url"
            class="nav-item"
            target="_blank"
            >{{ item.name }}</a
          >
          <nuxt-link
            v-else
            :key="index"
            :exact="item.exact"
            :to="localePath(item.url)"
            class="nav-item"
            >{{ item.name }}</nuxt-link
          >
        </template>
        <!-- <nuxt-link class="nav-item">{{ 'item.name' }}</nuxt-link> -->
      </nav>
      <div v-if="showSp" class="sp-menu">
        <button class="btn-close" @click="showSp = false"></button>
        <div class="sp-box">
          <a
            v-for="(item, index) in navList"
            :key="index"
            href="javascript:;"
            class="sp-item"
            @click="go(item)"
            >{{ item.name }}</a
          >
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  data() {
    this.navList = [
      {
        url: '/jp',
        name: 'ホームページ',
        exact: true
      },
      {
        url: '/jp/about-us',
        name: 'BIGO LIVEについて'
      },
      {
        url: '/jp/news',
        name: '最新情報'
      },
      {
        url: '/jp/contact-us',
        name: 'お問い合わせ'
      },
      {
        url: 'https://www.bigo.tv',
        name: '配信を見る',
        _blank: true
      }
    ];
    return {
      showSp: false
    };
  },
  methods: {
    goHome() {
      this.$router.push(this.localeRoute('/jp'));
    },
    go(item) {
      if (item._blank) {
        window.open(item.url, '_blank');
        return;
      }
      this.$router.push(this.localePath(item.url));
      this.showSp = false;
    }
  }
};
</script>
<style lang="scss" scoped>
@import '~assets/scss/mixin.scss';

.Jp-PageHead-Component {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  // min-width: 1280px;
  height: 80px;
  margin: 0 auto;
  z-index: 9999;
  background: #fff;

  .inner {
    width: 100%;
    height: 80px;
    max-width: 1400px;
    padding: 0 60px;
    margin: 0 auto;
    overflow: hidden;
  }
}

.logo {
  position: relative;
  top: 16px;
  float: left;

  @include in-rtl {
    float: right;
  }

  a {
    display: inline-block;
    height: 45px;

    img {
      height: 45px;
    }
  }
}

.spmenuopen {
  display: none;
  margin-top: 25px;
  margin-right: 20px;
  border-top: 3px solid #000;
  border-bottom: 3px solid #000;
  width: 21px;
  height: 21px;
  position: relative;
  cursor: pointer;

  &::before {
    content: '';
    position: absolute;
    display: block;
    top: 0;
    bottom: 0;
    background-color: #000;
    height: 3px;
    width: 100%;
    margin: auto;
  }
}

.nav {
  overflow: hidden;
  float: right;
  line-height: 80px;

  .nav-item {
    float: left;
    margin: 0 12px;
    font-size: 16px;
    color: #8a8f99;

    &.nuxt-link-active {
      position: relative;
      color: rgba(47, 48, 51, 1);

      &::before {
        content: '';
        display: inline-block;
        position: absolute;
        top: 63px;
        left: 50%;
        transform: translate(-50%, 0);
        width: 12px;
        height: 3px;
        background: #2f3033;
        border-radius: 1.5px;
      }
    }

    &:hover {
      color: rgba(47, 48, 51, 1);
    }
  }
}

.sp-menu {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);

  .btn-close {
    position: fixed;
    top: 30px;
    right: 30px;
    width: 20px;
    height: 20px;
    color: #fff;
    background-image: url('~@assets/img/jp/btn-close.png');
    background-size: cover;
  }
}

@media screen and (max-width: 640px) {
  .nav {
    display: none;
  }

  .Jp-PageHead-Component .inner {
    padding: 0 20px;
  }

  .spmenuopen {
    display: block;
    float: right;
  }

  .sp-box {
    display: flex;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 150px 0;

    .sp-item {
      position: relative;
      text-align: center;
      color: #fff;

      &.nuxt-link-active::before {
        content: '';
        display: inline-block;
        position: absolute;
        top: 35px;
        left: 50%;
        transform: translate(-50%, 0);
        width: 40px;
        height: 2px;
        background: #fff;
        border-radius: 2px;
      }
    }
  }
}
</style>
